/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid using Icon from '@fluentui/react', as this package has already migrated to Fluent UI 9. Use a JSX SVG icon from '@fluentui/react-icons' instead. */
import { Icon } from '@fluentui/react';
import Hybrid from '../assets/Hybrid.svg';
import Desktop from '../assets/Desktop.svg';
import Office from '../assets/Office.svg';
import LocationDismissRegular from 'owa-fluent-icons-svg/lib/icons/LocationDismissRegular';
import { icon, noLocationIconStyles } from './WorkLocationButtonIcons.scss';

export const OfficeIcon: JSX.Element = <img src={Office} className={icon} />;
export const HybridIcon: JSX.Element = <img src={Hybrid} className={icon} />;
export const RemoteIcon: JSX.Element = <img src={Desktop} className={icon} />;
export const NoWorkLocationIcon: JSX.Element = (
    <Icon className={noLocationIconStyles} iconName={LocationDismissRegular} />
);
